import React from 'react'
import NeutralMark from './NeutralMark'
import { NEUTRAL_AUTH_CSS } from './neutralAuthCss'

const NeutralAuthLayout = ({ brandLabel, headline, lede, features, children }) => (
  <>
    <style>{NEUTRAL_AUTH_CSS}</style>
    <div className="na-root">
      <section className="na-left">
        <div className="na-brand">
          <NeutralMark size={36} />
          <span>{brandLabel}</span>
        </div>
        <div className="na-hero">
          <p className="na-headline">
            {headline[0]}
            <br />
            <span>{headline[1]}</span>
          </p>
          <p className="na-lede">{lede}</p>
          <ul className="na-features">
            {features.map(({ Icon, title, text }) => (
              <li key={title}>
                <span className="na-feature-icon">
                  <Icon size={22} />
                </span>
                <div>
                  <p className="na-feature-title">{title}</p>
                  <p className="na-feature-text">{text}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="na-decor" aria-hidden="true">
          <span className="na-orb na-orb-1" />
          <span className="na-orb na-orb-2" />
          <span className="na-panel" />
        </div>
      </section>
      <main className="na-right">
        <div className="na-mobile-brand">
          <NeutralMark size={32} />
          <span>{brandLabel}</span>
        </div>
        <p className="na-assurance">Secure • Private • Always here</p>
        <div className="na-card">{children}</div>
      </main>
    </div>
  </>
)

export default NeutralAuthLayout
